module.exports = __webpack_public_path__ + "img/shield-x.c7395ca7.svg";